/**
 * Where the web app serves the legal pages: public, linkable URLs the marketing site, the app
 * stores and signup can point at. The two aliases redirect to these.
 */
export const TERMS_PATH = '/terms';
export const PRIVACY_PATH = '/privacy';
export const TERMS_ALIAS_PATH = '/terms-and-conditions';
export const PRIVACY_ALIAS_PATH = '/privacy-policy';
